import { buttonStyle } from "../mui-styles/mui-button-styles";
import { CustomButtonOwnProps, CustomPalette } from "../mui-types";

interface IButtonVariants {
  palette: CustomPalette;
  ownerState: CustomButtonOwnProps;
}

export const buttonVariants = ({ palette, ownerState }: IButtonVariants) => [
  {
    props: { variant: "primary" },
    style: {
      ...buttonStyle(palette).main,
      ...(ownerState?.purpleGradient && buttonStyle(palette).purpleGradient),
      ...(ownerState?.pinkGradient && buttonStyle(palette).pinkGradient),
      ...(ownerState?.textOnly && buttonStyle(palette).textOnlyPrimary),
      ...(ownerState?.maxWidth && { maxWidth: ownerState.maxWidth }),
    },
  },
  {
    props: { variant: "secondary" },
    style: {
      ...buttonStyle(palette).secondary,
      ...(ownerState?.purpleGradient && buttonStyle(palette).purpleGradient),
      ...(ownerState?.pinkGradient && buttonStyle(palette).pinkGradient),
      ...(ownerState?.textOnly && buttonStyle(palette).textOnlySecondary),
      ...(ownerState?.maxWidth && { maxWidth: ownerState.maxWidth }),
    },
  },
  {
    props: { size: "small" },
    style: {
      ...buttonStyle(palette).small,
    },
  },
  {
    props: { size: "medium" },
    style: {
      ...buttonStyle(palette).medium,
    },
  },
  {
    props: { size: "large" },
    style: {
      ...buttonStyle(palette).large,
    },
  },
  {
    props: { rounded: true },
    style: {
      ...buttonStyle(palette).secondary,
    },
  },
];
